const agentEdit = {
    path: 'agent/edit/:merchantId',
    component: resolve => require(['../../../../../pages/admin/channel/agent/edit'], resolve),
    meta: {
        requireAuth: true
    }
}

export default agentEdit